<div class="content-header">
  <h1>General Settings</h1>
</div>

@if (loading) {
  <div class="loading-state">
    <gs-loader mode="contained" label="Loading general settings" />
  </div>
} @else {
  <div class="gs-fill">
    <div class="general-settings">
      <sdc-card headerTitle="Default Buyer type" class="form-section">
        <div class="form-grid">
          <div class="input-block">
            <label class="label-text" for="general-settings-buyer-type-name">
              Default Buyer type — name
              <span class="mandatory-asterisk">*</span>
            </label>
            <sdc-input
              name="general-settings-buyer-type-name"
              type="text"
              [control]="buyerTypeNameControl"
              [errorMessage]="'This field is required'"
              errorDisplayMode="always"
              [attr.data-cy]="'general-settings-buyer-type-name'" />
          </div>
          <div class="input-block">
            <label class="label-text" for="general-settings-buyer-type-id">
              Default Buyer type — ID
              <span class="mandatory-asterisk">*</span>
            </label>
            <sdc-input
              name="general-settings-buyer-type-id"
              type="number"
              [control]="buyerTypeIdControl"
              [errorMessage]="'Must be a positive number'"
              errorDisplayMode="always"
              [attr.data-cy]="'general-settings-buyer-type-id'" />
          </div>
        </div>
      </sdc-card>

      <sdc-card headerTitle="Hold codes" class="form-section">
        <div class="form-grid">
          <div class="input-block">
            <span class="label-text">Group hold code(s)</span>
            <tagify
              name="regular-hold-codes"
              class="tags-textarea"
              [formControl]="regularHoldCodesForm"
              inputClass="w-full flex justify-start items-start"
              [settings]="regularHoldCodesSettings"
              data-cy="general-settings-regular-hold-codes"></tagify>
          </div>
          <div class="input-block">
            <span class="label-text">ADA hold code(s)</span>
            <tagify
              name="ada-hold-codes"
              class=""
              [formControl]="adaHoldCodesForm"
              inputClass="w-full flex justify-start items-start"
              [settings]="adaHoldCodesSettings"
              data-cy="general-settings-ada-hold-codes"></tagify>
          </div>
        </div>
      </sdc-card>

      <sdc-card headerTitle="Min and Max tickets" class="form-section">
        <div class="form-grid">
          <div class="input-block">
            <label class="label-text" for="general-settings-min-tickets">
              Min tickets <span class="mandatory-asterisk">*</span>
            </label>
            <sdc-input
              name="general-settings-min-tickets"
              type="number"
              [control]="minTicketsControl"
              [errorMessage]="'Must be a positive integer'"
              errorDisplayMode="always"
              [attr.data-cy]="'general-settings-min-tickets'" />
          </div>
          <div class="input-block">
            <label class="label-text" for="general-settings-max-tickets">
              Max tickets <span class="mandatory-asterisk">*</span>
            </label>
            <sdc-input
              name="general-settings-max-tickets"
              type="number"
              [control]="maxTicketsControl"
              [errorMessage]="'Must be a positive integer'"
              errorDisplayMode="always"
              [attr.data-cy]="'general-settings-max-tickets'" />
          </div>
        </div>
        @if (hashValidator.minMaxOrder) {
          <p class="order-error">
            Min tickets must be less than or equal to max tickets.
          </p>
        }
      </sdc-card>
    </div>
  </div>

  @if (authStore.canEdit()) {
    <div class="actions-row">
      <sdc-button
        variant="primary"
        type="button"
        [disabled]="saving"
        (onClick)="save()"
        [attr.data-cy]="'general-settings-save'">
        {{ saving ? 'Saving…' : 'Save' }}
      </sdc-button>
    </div>
  }
}
